import React, { useReducer, useContext, useEffect } from 'react';
import API from '../../../../api/axios';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import FullCard from '../../../../components/Card/FullCard';

const Cities = React.memo((props) => {
  // -- Functions:
  const initialState = {
    fields: {
      origin: {
        option: { label: 'گرمسار', value: '5e3dbf566b09850543a67a9a' },
        error: null,
      },
      destination: { option: null, error: null },
      percentAffected: { text: '', error: null },
      baseRate: { text: '', error: null },
    },
    cities: {
      options: null,
      isLoaded: false,
    },
    isLoaded: false,
    select: {},
    errors: [],
  };

  function reducer(state, action) {
    const { payload, type } = action;

    switch (type) {
      case 'CITIES':
        return {
          ...state,
          cities: {
            options: payload,
            isLoaded: true,
          },
        };
      case 'ORIGIN':
        return {
          ...state,
          fields: { ...state.fields, origin: { option: payload } },
        };
      case 'DESTINATION':
        return {
          ...state,
          fields: { ...state.fields, destination: { option: payload } },
        };
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      case 'CHANGE_FIELDS':
        return {
          ...state,
          fields: { ...state.fields, [payload.name]: { text: payload.value } },
        };
      case 'SET_CITY_PERCENT':
        return {
          ...state,
          fields: {
            ...state.fields,
            baseRate: {
              text: payload.baseRate,
              error: null,
            },
            percentAffected: {
              text: payload.percentAffected,
              error: null,
            },
          },
        };
      case 'CLEAR_FORM':
        return {
          ...state,
          fields: {
            ...state.fields,
            baseRate: { ...state.fields.baseRate, error: null },
            percentAffected: { text: '', error: null },
          },
        };
      case 'ERROR':
        return {
          ...state,
          fields: {
            ...state.fields,
            [payload.name]: {
              ...state.fields[payload.name],
              error: payload.error,
            },
          },
          errors: [...state.errors, payload.error],
        };
      case 'CLEAR_ERRORS':
        errors = [];
        return { ...state, errors: [] };
      case 'SET_ORIGIN_CITY':
        return {
          ...state,
          fields: {
            ...state.fields,
            origin: {
              option: {
                label: payload.label,
                value: payload.value,
              },
            },
          },
        };
      case 'SET_BASERATE':
        return {
          ...state,
          fields: {
            ...state.fields,
            baseRate: { ...state.fields.baseRate, text: payload },
          },
        };
      default:
        return { ...state };
    }
  }
  const handleChangeFields = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    dispatch({ type: 'CHANGE_FIELDS', payload: { name, value } });
  };
  const loadCities = async () => {
    try {
      const response = await API.get(`/api/v1/admin/city/list`);
      const cities = response.data.map((c) => {
        return { label: c.title, value: c._id };
      });
      return cities;
    } catch (err) {
      console.error(err);
    }
  };
  const loadFromAPI = async () => {
    try {
      const cities = await loadCities();
      dispatch({ type: 'CITIES', payload: cities });
    } catch (err) {
      console.error(err);
    }
  };
  const error = (fieldName, errorMsg) => {
    errors.push(errorMsg);
    dispatch({
      type: 'ERROR',
      payload: { name: fieldName, error: errorMsg },
    });
  };

  const saveCityPercent = async () => {
    dispatch('CLEAR_ERRORS');
    state.fields.origin.option == null &&
      error('origin', 'شهر مبدا بایستی انتخاب شود');
    state.fields.destination.option == null &&
      error('destination', 'شهر مقصد بایستی انتخاب شود');
    !state.fields.percentAffected.text &&
      error('percentAffected', 'ضریب شهر را وارد نمایید');
    !state.fields.baseRate.text &&
      error('baseRate', 'مبلغ پایه را وارد نمایید');
    if (errors.length > 0) {
      props.showMessage(
        2,
        'tr',
        'اخطار',
        errors.map((e, i) => <li key={i}>{e}</li>)
      );
    } else {
      const data = {
        origin: state.fields.origin.option.value,
        destination: state.fields.destination.option.value,
        percentAffected: state.fields.percentAffected.text,
        baseRate: state.fields.baseRate.text,
      };
      API(`/api/v1/admin/city/pair/`, {
        method: 'put',
        data,
      })
        .then((res) => {
          props.showMessage(
            1,
            'tr',
            'ثبت شد',
            `ضریب شهر با موفقیت بروزرسانی شد`
          );
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };
  const handleChangeOrigin = async (option) => {
    dispatch({ type: 'ORIGIN', payload: option });
  };
  const handleChangeDestination = async (option) => {
    dispatch({
      type: 'DESTINATION',
      payload: option,
    });
  };

  const getCityPercent = async () => {
    const { origin, destination } = state.fields;

    origin.option &&
      destination.option &&
      API(
        `/api/v1/admin/city/pair/${origin.option.value}/${destination.option.value}`
      )
        .then((res) => {
          if (res.data && res.data.baseRate && res.data.percentAffected) {
            dispatch({
              type: 'SET_CITY_PERCENT',
              payload: {
                baseRate: res.data.baseRate,
                percentAffected: res.data.percentAffected,
              },
            });
          } else {
            dispatch({ type: 'CLEAR_FORM' });
          }
        })
        .catch((err) => {
          console.error(err);
        });
  };

  // -- Variables:
  const [state, dispatch] = useReducer(reducer, initialState);
  var errors = [];

  // Render:

  const insertCitiesPercent = (
    <form style={{ width: 500 }}>
      <Grid container direction="column" alignItems="stretch" spacing={1}>
        <Grid item>
          {state.cities.isLoaded ? (
            <Select
              options={state.cities.options}
              isMulti={false}
              isSearchable={true}
              placeholder={'شهر مبدا ...'}
              value={state.fields.origin.option}
              onChange={(option) => {
                handleChangeOrigin(option);
              }}
              noOptionsMessage={() => 'شهری یافت نشد'}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  height: 56,
                }),
                menu: (provided, state) => ({
                  ...provided,
                  zIndex: 2,
                }),
              }}
            />
          ) : (
            <Skeleton height={56} />
          )}
          <small>{state.fields.origin.error}</small>
        </Grid>
        <Grid item>
          {state.cities.isLoaded ? (
            <Select
              options={state.cities.options}
              isMulti={false}
              isSearchable={true}
              placeholder={'شهر مقصد ...'}
              value={state.fields.destination.option}
              onChange={(option) => {
                handleChangeDestination(option);
              }}
              noOptionsMessage={() => 'شهری یافت نشد'}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  height: 56,
                }),
                menu: (provided, state) => ({
                  ...provided,
                  zIndex: 2,
                }),
              }}
            />
          ) : (
            <Skeleton height={56} />
          )}
          <small>{state.fields.destination.error}</small>
        </Grid>
        <Grid item>
          <TextField
            type="number"
            name="baseRate"
            value={state.fields.baseRate.text}
            onChange={handleChangeFields}
            label="نرخ پایه به ازای هر کیلومتر به تومان"
            fullWidth
            variant="outlined"
          />
          <small>{state.fields.baseRate.error}</small>
        </Grid>
        <Grid item>
          <TextField
            type="number"
            name="percentAffected"
            value={state.fields.percentAffected.text}
            onChange={handleChangeFields}
            label="ضریب موثر در کرایه این مسیر (درصد)"
            fullWidth
            variant="outlined"
          />
          <small>{state.fields.percentAffected.error}</small>
        </Grid>

        <Grid item>
          <Button
            onClick={saveCityPercent}
            color="secondary"
            size="large"
            variant="contained"
            fullWidth
          >
            تنظیم ضریب شهر
          </Button>
        </Grid>
      </Grid>
    </form>
  );

  const body = (
    <FullCard
      title={props.config.name}
      category="مقدار اولیه مبلغ به ازای هر یک کیلومتر می باشد"
    >
      {insertCitiesPercent}
    </FullCard>
  );

  useEffect(() => {
    loadFromAPI();
    (async () => {
      try {
        const { data } = await API.get(`/api/v1/admin/settings/waybills`);
        data &&
          data.settings &&
          dispatch({ type: 'SET_BASERATE', payload: data.settings.baserate });
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  useEffect(() => {
    getCityPercent();
  }, [state.fields.origin, state.fields.destination]);
  return body;
});
export default Cities;
